import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../lib/api';
import type { SavedFilterDto, SaveFilterRequest } from '../lib/types';

const KEY = ['me', 'filters'];

export function useSavedFilters() {
  return useQuery({
    queryKey: KEY,
    queryFn: () => apiClient.get<SavedFilterDto[]>('/api/me/filters'),
  });
}

export function useCreateSavedFilter() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (req: SaveFilterRequest) => apiClient.post<SavedFilterDto>('/api/me/filters', req),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}

export function useUpdateSavedFilter() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, req }: { id: number; req: SaveFilterRequest }) =>
      apiClient.put<SavedFilterDto>(`/api/me/filters/${id}`, req),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}

export function useDeleteSavedFilter() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => apiClient.del<void>(`/api/me/filters/${id}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}
